export default __webpack_public_path__ + "static/media/rl.20c82687.png";